// extracted by mini-css-extract-plugin
module.exports = {"container":"Map_container__l7aZ0","contactDetails":"Map_contactDetails__v4_I2","map":"Map_map__UHs_d"};